import BannerAward2024 from '../img/banner/Award2024.png';
import Logo from '../img/event/2603/logo.png';
import Title from '../img/event/2603/title.png';
import MainIllust from '../img/event/2603/main-illust.png';
import Subtitle1 from '../img/event/2603/subtitle1.png';
import Subtitle2 from '../img/event/2603/subtitle2.png';
import Online_Session from '../img/event/online-session.png';
import { DoubleLineWithCursorButton, DoubleLineButton } from './common/Button';
import { TextBox } from './common/TextBox';
const HomeschoolEvent202603 = () => {
  return (
    <>
      {/* 배너 영역 */}
      <img src={BannerAward2024} alt="Award2024" className="m-auto w-full" />

      {/* 프로모션 섹션 1 */}
      {/* 대지 */}
      <div className="flex items-center justify-center overflow-hidden bg-[#FF641D]">
        {/* 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="m-auto flex max-w-[720px] flex-col gap-10 px-5 py-14 sm:gap-20 sm:py-20">
          <div className="flex flex-col items-center justify-center gap-10">
            {/* 젭스 영어교실 로고 */}
            <div className="mx-auto mb-5 flex max-w-[120px] sm:mb-10 sm:max-w-[160px]">
              <img src={Logo} alt="젭스 영어교실 로고" />
            </div>

            {/* 타이틀 섹션 */}
            <div className="flex flex-col items-center justify-center gap-5 sm:gap-10">
              {/* 타이틀 - 이미지 */}
              <div className="m-auto flex max-w-[280px] flex-col sm:max-w-[320px]">
                <img
                  src={Title}
                  alt="새학기, 말씀과 영어로 시작하는 성장의 3월!"
                />
              </div>

              {/* 서브타이틀 텍스트 */}
              <div className="text-center text-base font-medium text-white sm:text-2xl">
                말씀과 영어 말하는 소리가 끊이지 않는 공간! <br />
                그곳이 <span className="font-bold">젭스영어교실</span>입니다.
              </div>
            </div>

            <div className="mx-auto flex max-w-[320px] sm:max-w-[480px]">
              <img src={MainIllust} alt="26년 3월 키 일러스트" />
            </div>

            {/* 말풍선 */}
            <div className="flex w-full items-center justify-center gap-6 rounded-full bg-[#FF3A2080] px-6 py-6 sm:rounded-full sm:px-10 sm:py-5">
              <p className="text-center text-base font-medium text-white sm:text-lg">
                기존 젭스영어성경홈스쿨이
                <br /> 2026년부터{' '}
                <span className="font-bold"> ‘젭스영어교실’로</span>
                <br /> 새롭게 리브랜딩되었습니다.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 2 */}
      {/* 대지 */}
      <div className="flex items-center justify-center overflow-hidden bg-[#FFE9D1]">
        {/* 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="m-auto flex max-w-[720xpx] flex-col gap-10 px-5 py-14 sm:gap-20 sm:py-20">
          {/* 말풍선 섹션 */}
          <section className="mx-auto flex flex-col items-center justify-center gap-3 text-lg font-semibold sm:gap-5">
            {/* 타이틀 이미지 */}
            <div className="mx-auto mb-2 flex max-w-[160px] sm:mb-4 sm:max-w-[240px]">
              <img src={Subtitle1} alt="3월 프로모션 혜택" />
            </div>
            {/* 말풍선 1 */}
            <div className="flex w-full items-center justify-center gap-6 rounded-full bg-[#FB7F30] px-6 py-6 drop-shadow-sm sm:rounded-full sm:px-10 sm:py-5">
              <p className="text-center text-base font-medium text-white sm:text-lg">
                가정· 공부방· 교습소· 대안학교 활용 가능
                <br />
                누구나 가르칠 수 있는{' '}
                <span className="font-bold">교사용 콘텐츠 제공</span>
              </p>
            </div>
            {/* 말풍선 2 */}
            <div className="flex w-full items-center justify-center gap-6 rounded-full bg-[#FF641D] px-6 py-6 drop-shadow-sm sm:rounded-full sm:px-10 sm:py-5">
              <p className="text-center text-base font-medium text-white sm:text-lg">
                <span className="font-bold">새학기를 위한 특별 혜택! 🎁</span>
                <br />
                3월 등록 할인 + 기간별 포인트백 혜택
              </p>
            </div>
            {/* 말풍선 3 */}
            <div className="flex w-full items-center justify-center gap-6 rounded-full bg-[#FF4F1F] px-6 py-6 drop-shadow-sm sm:rounded-full sm:px-10 sm:py-5">
              <p className="text-center text-base font-medium text-white sm:text-lg">
                <span className="font-bold">🎁 교재 사은품!</span>
                <br />
                A.D.영어학습법,
                <br className="sm:hidden" />
                성경말씀 영어로 암송하기(랜덤)
                <br />
                영어로 땡스기빙
              </p>
            </div>
          </section>

          {/* 설명회 섹션 */}
          <div className="m-auto flex max-w-[480px] flex-col gap-5">
            {/* 타이틀 섹션 */}
            <section className="flex flex-col text-center sm:gap-1">
              {/* 타이틀 이미지 */}
              <div className="mx-auto mb-2 flex max-w-[160px] sm:mb-4 sm:max-w-[240px]">
                <img src={Subtitle2} alt="온라인 설명회 안내" />
              </div>
              {/* 서브타이틀 텍스트 */}
              <div className="text-base font-normal text-black sm:text-lg">
                젭스영어교실의{' '}
                <span className="font-semibold">비전, 커리큘럼, 이용 방법</span>
                을
                <br />
                온라인 설명회에서 자세히 알려드립니다.
              </div>
            </section>

            {/* 이미지 */}
            <div className="relative m-auto w-full">
              <img src={Online_Session} alt="젭스영어교실 온라인설명회" />
            </div>

            {/* 버튼 */}
            <DoubleLineButton
              onClick={() => {
                window.open('https://forms.gle/hYg6Q4YQ4tMcBFb58');
              }}
              borderColor="border-white"
              bgColor="bg-black"
              hoverBgColor="hover:bg-black/70"
              textColor="text-white"
            >
              <div className="p-3 text-xl font-bold sm:p-5 sm:text-4xl">
                지금 설명회 신청하기
              </div>
            </DoubleLineButton>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 3 */}
      <div className="flex items-center justify-center bg-[#FF6A25]">
        {/* 실제 컨텐츠 레이어 : 배경 레이어 위에 표시됨 */}
        <div className="m-auto flex max-w-[720px] flex-col gap-10 px-5 py-14 sm:gap-20 sm:py-20">
          <div className="flex flex-col items-center justify-center gap-5 sm:gap-10">
            {/* 타이틀 */}
            <p className="text-center text-2xl font-extrabold text-white sm:text-4xl">
              젭스영어교실 신청 시,
              <br />
              수업 콘텐츠부터 디자인 자료
              <br />
              믿음의 커뮤니티까지!
            </p>
            {/* 서브타이틀 */}
            <p className="text-md text-center font-medium text-white sm:text-2xl">
              젭스영어교실은
              <br />
              성경 스토리 → 청크 학습 → 스피킹 → 발표까지
              <br />한 달에 교재 1세트로 완성되는 프로그램입니다
            </p>
            {/* 박스 */}
            <section className="flex w-full flex-col gap-5 sm:gap-8">
              <div className="grid auto-rows-fr grid-cols-1 gap-5">
                <TextBox className="h-full">
                  <p className="text-xl font-extrabold text-black md:text-3xl">
                    청크로 배우는{' '}
                    <span className="text-[#FF6A25]">말문이 터지는 영어</span>
                  </p>
                </TextBox>
                <TextBox className="h-full">
                  <p className="text-xl font-extrabold text-[#FF6A25] md:text-3xl">
                    발명특허 받은 교수법으로
                    <br />
                    <span className="text-black">
                      성경 스토리를 확실하게 암송
                    </span>
                  </p>
                </TextBox>
                <TextBox className="h-full">
                  <p className="text-xl font-extrabold text-[#FF6A25] md:text-3xl">
                    스토리텔링 & 발표 학습
                  </p>
                </TextBox>
              </div>
            </section>
          </div>

          {/* 버튼 */}
          <DoubleLineWithCursorButton
            onClick={() => {
              window.open('https://jebs.kr/shop/details/NKyRTHjIgiewcumT');
            }}
            bgColor="bg-black"
            hoverBgColor="hover:bg-black/70"
            textColor="text-white"
          >
            <div className="p-3 text-xl font-bold sm:p-5 sm:text-4xl">
              3월 등록 혜택 확인
            </div>
          </DoubleLineWithCursorButton>
        </div>
      </div>
    </>
  );
};

export default HomeschoolEvent202603;
